import React, { useState } from 'react';
import caminemosjuntas from './images/caminemosjuntas.jpeg';
import logo from './images/Imagotipocamju.png'
import { Link } from 'react-router-dom';

const Banner = ({ id }) => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div id={id || 'Banner'} className="font-sans bg-[#f8faf9]">
      <div className="relative overflow-hidden">
        <header className="absolute top-0 right-0 left-0 z-20 border-b border-white/20 bg-[#173f46]/90 px-4 py-3 text-white backdrop-blur-sm md:px-8">
          <div className="mx-auto flex max-w-7xl items-center justify-between gap-4">
            <a href="#Banner" aria-label="Caminemos Juntas, inicio">
              <img className="h-9 w-auto" src={logo} alt="Caminemos Juntas" />
            </a>
            <nav className="hidden items-center gap-1 md:flex" aria-label="Navegación principal">
              <a href="#EncuentraAyuda" className="rounded-md px-3 py-2 text-sm hover:bg-white/15">Encontrar ayuda</a>
              <a href="#estamoscontigo" className="rounded-md px-3 py-2 text-sm hover:bg-white/15">Acompañamiento</a>
              <a href="#contacto" className="rounded-md px-3 py-2 text-sm hover:bg-white/15">Contacto</a>
            </nav>
            <div className="flex items-center gap-2">
              <a href="tel:911" className="rounded-md bg-[#c94b4b] px-3 py-2 text-sm font-semibold shadow-sm hover:bg-[#a83e3e]">
                Llamar al 911
              </a>
              <button
                type="button"
                className="rounded-md border border-white/50 px-3 py-2 text-sm font-semibold md:hidden"
                aria-expanded={menuOpen}
                aria-controls="mobile-navigation"
                onClick={() => setMenuOpen((open) => !open)}
              >
                Menú
              </button>
            </div>
          </div>
          {menuOpen && (
            <nav id="mobile-navigation" className="mx-auto mt-3 flex max-w-7xl flex-col gap-1 border-t border-white/20 pt-2 md:hidden" aria-label="Navegación móvil">
              <a href="#EncuentraAyuda" className="rounded-md px-3 py-2 text-sm hover:bg-white/15" onClick={() => setMenuOpen(false)}>Encontrar ayuda</a>
              <a href="#estamoscontigo" className="rounded-md px-3 py-2 text-sm hover:bg-white/15" onClick={() => setMenuOpen(false)}>Acompañamiento</a>
              <a href="#contacto" className="rounded-md px-3 py-2 text-sm hover:bg-white/15" onClick={() => setMenuOpen(false)}>Contacto</a>
            </nav>
          )}
        </header>

        <img className="h-[560px] w-full object-cover object-top md:h-[620px]" src={caminemosjuntas} alt="Mujeres caminando juntas" />
        <div className="absolute inset-0 bg-[#173f46]/65" aria-hidden="true" />
        <div className="absolute inset-x-4 top-1/2 mx-auto flex max-w-3xl -translate-y-1/2 flex-col items-center px-2 text-center text-white sm:inset-x-8">
          <p className="mb-3 text-sm font-semibold uppercase tracking-[0.18em] text-[#b9e1d8]">Acompañamiento gratuito y confidencial</p>
          <h1 className="text-4xl font-bold leading-tight md:text-6xl">¡Caminemos Juntas!</h1>
          <p className="mt-4 max-w-xl text-base text-white/90 sm:text-lg md:text-xl">Encuentra orientación, apoyo y contactos seguros para dar el siguiente paso.</p>
          <div className="mt-7 flex w-full max-w-xl flex-col gap-3 sm:flex-row sm:justify-center">
            <a href="#EncuentraAyuda" className="rounded-md bg-[#f2c14e] px-5 py-3 text-center font-semibold text-[#173f46] hover:bg-[#e6b33b]">
              Necesito ayuda ahora
            </a>
            <Link to="/numeros-de-emergencia" className="rounded-md border border-white/70 px-5 py-3 text-center font-semibold text-white hover:bg-white/15">
              Buscar un centro cercano
            </Link>
          </div>
        </div>
      </div>
    </div>

  );
};

export default Banner;
